// Basic obscenity/explicit content filter
// In production, replace with a proper API like Perspective API or similar

const BLOCKED_PATTERNS = [
  /\b(fuck|shit|ass|bitch|bastard|cunt|dick|pussy|cock|whore|slut|nigger|faggot)\b/gi,
  /\b(sex|porn|nude|naked|horny|masturbat|orgasm|erect|boob|tits|vagina|penis)\b/gi,
  /\b(kill yourself|kys|go die|end your life|suicide method)\b/gi,
  /\b(rape|molest|Chut|assault|abuse)\b/gi,
];

const WARN_PATTERNS = [
  /\b(hate|stupid|idiot|moron|dumb|loser|ugly)\b/gi,
];

export const moderateContent = (text) => {
  if (!text || typeof text !== 'string') return { safe: true, reason: null };

  for (const pattern of BLOCKED_PATTERNS) {
    if (pattern.test(text)) {
      pattern.lastIndex = 0; // reset regex state
      return {
        safe: false,
        reason: 'Your post contains content that violates HealHub community guidelines. Please keep the space safe and supportive.',
        level: 'block'
      };
    }
    pattern.lastIndex = 0;
  }

  for (const pattern of WARN_PATTERNS) {
    if (pattern.test(text)) {
      pattern.lastIndex = 0;
      return {
        safe: true,
        reason: 'Please keep the conversation kind and supportive 💛',
        level: 'warn'
      };
    }
    pattern.lastIndex = 0;
  }

  return { safe: true, reason: null };
};

export const sanitizeText = (text) => {
  // Remove HTML tags
  return text.replace(/<[^>]*>/g, '').trim();
};

export const extractMentions = (text) => {
  const mentionPattern = /@(\w+)/g;
  const mentions = [];
  let match;
  while ((match = mentionPattern.exec(text)) !== null) {
    mentions.push(match[1]);
  }
  return mentions;
};

export const formatTimeAgo = (timestamp) => {
  const now = new Date();
  const date = new Date(timestamp);
  const seconds = Math.floor((now - date) / 1000);

  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return date.toLocaleDateString('en-IN', { day: 'numeric', month: 'short' });
};

export const TAGS = [
  { label: 'Discussion', emoji: '💬', color: '#4a7c6f' },
  { label: 'Question', emoji: '🤔', color: '#e8a135' },
  { label: 'Rant', emoji: '😤', color: '#c95b3d' },
  { label: 'Idea', emoji: '💡', color: '#6b5b95' },
  { label: 'Support', emoji: '🤗', color: '#e87070' },
  { label: 'Victory', emoji: '🎉', color: '#4CAF50' },
];

export const INTERESTS = [
  'Mental Health', 'Anxiety', 'Depression', 'Stress', 
  'Mindfulness', 'Relationships', 'Self-Improvement', 
  'Career', 'Motivation', 'Grief', 'Loneliness', 'General'
];

export const SORT_OPTIONS = [
  { value: 'hot', label: '🔥 Hot' },
  { value: 'new', label: '✨ New' },
  { value: 'top', label: '⬆️ Top' },
];